import React from 'react'

import bemit from '@function/bemit'

export default function FieldError ({ ...props })
{
	if (!props.error) return null;

	return (
		<div className={ bemit('c-field-error', props.bemit || []) }>
			{ props.error }
		</div>
	);
}